import {createSlice} from "@reduxjs/toolkit";
import {extraReducers} from "./action";


const initialState = {
    menu: [],
    loadingStatus: 'loaded',

}

const navAdditionalMenuSlice = createSlice({
        name: 'navAdditionalMenu',
        initialState,
        reducers: {},
        extraReducers: extraReducers
    }
);

const {reducer} = navAdditionalMenuSlice;

export default reducer;
